import { render, staticRenderFns } from "./popularityConfig.vue?vue&type=template&id=60b7742e&scoped=true&"
import script from "./popularityConfig.vue?vue&type=script&lang=js&"
export * from "./popularityConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7742e",
  null
  
)

export default component.exports